"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormField = exports.FormLayout = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.FormLayout = styled_components_1.default.form(({ theme: { media } }) => ({
    '.row': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        paddingTop: '20px',
        [media.mobile]: {
            flexDirection: 'column',
            paddingTop: '0',
        },
    },
}));
exports.FormField = styled_components_1.default.div(({ theme: { media } }) => ({
    width: '100%',
    paddingRight: '11px',
    '&:last-child': {
        paddingRight: '0',
    },
    [media.mobile]: {
        paddingRight: '0',
        '&:not(:empty)': {
            paddingTop: '20px',
        },
    },
}));
//# sourceMappingURL=FormLayout.js.map